import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const PromocodeCheckResponseSchema = z
  .object({
    data: z.object({
      id: z.number(),
      code: z.string(),
      discount: z.number(),
      type: z.string(),
    }),
  })
  .transform((data) => data);

export type TPromocodeCheckResponse = z.infer<typeof PromocodeCheckResponseSchema>;
export type TPromocodeCheckData = TPromocodeCheckResponse['data'];

export const PromocodeApplyResponseSchema = z
  .object({
    data: z.object({
      price_usd: z.number(),
      price_btc: z.number(),
      price_ltc: z.number(),
      price_ust: z.number(),
      price_eth: z.number(),
      discount: z.number(),
      type: z.union([z.literal('fixed'), z.literal('percent')]),
    }),
  })
  .transform(transformKeysToCamelCase);

export type TPromocodeApplyResponse = z.infer<typeof PromocodeApplyResponseSchema>;
export type TPromocodeApplyData = TPromocodeApplyResponse['data'];
